import { RouteHttpVerb } from "@devowl-wp/utils";
export var locationRestConsentPost = {
  path: "/consent",
  method: RouteHttpVerb.POST
};